import { useState } from 'react';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';

export const usePageNavigation = (fileType: string | null, numPages: number | null) => {
  const [input, setInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const pageNavigationPluginInstance = pageNavigationPlugin();

  const handleDocumentLoad = (e: { doc: { numPages: number } }) => {
    // This will be handled by the parent component via setNumPages
  };

  const handlePageChange = (e: { currentPage: number }) => {
    const newPage = e.currentPage + 1; // react-pdf-viewer uses 0-based indexing
    setCurrentPage(newPage);
  };

  const handleGoToPage = () => {
    if (fileType !== 'pdf') return;

    const pageNum = Number.parseInt(input, 10);
    if (Number.isNaN(pageNum) || pageNum < 1) {
      alert(`Please enter a valid page number (1-${numPages || '?'})`);
      return;
    }

    if (numPages && pageNum > numPages) {
      pageNavigationPluginInstance.jumpToPage(0);
      setCurrentPage(1);
      setInput('');
      return;
    }

    pageNavigationPluginInstance.jumpToPage(pageNum - 1);
    setCurrentPage(pageNum);
    setInput('');
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleGoToPage();
    }
  };

  return {
    input,
    setInput,
    currentPage,
    pageNavigationPluginInstance,
    handleDocumentLoad,
    handlePageChange,
    handleGoToPage,
    handleInputKeyDown
  };
};